export class CstEmail {
    custId: string;
    emailSeq: string;
    portfolioId: number;

}